import React from "react";
import FormCheck, { FormCheckProps } from "react-bootstrap/FormCheck";
import KC_Text from "../typography/KC_Text/KC_Text";
import { KC_Text_Sizes, KC_Weights } from "../ds_commons";
import "./styles.scss";

interface Props extends Omit<FormCheckProps, "as"> {}

const KC_Checkbox = (props: Props) => {
  return (
    <FormCheck
      {...props}
      label={
        <KC_Text
          text={props.label}
          size={KC_Text_Sizes.md}
          weight={KC_Weights.reg}
        />
      }
    />
  );
};

export default KC_Checkbox;
